import moment from 'moment';
// const today = moment('8:00 am', 'h:mm a')

const blankTour = (startDate) => {
  const dayString = moment(startDate).format('YYYY-MM-DD') + ' ';

  return {
    itemType: "tour",
    title: 'Tour Details',
    dayTypeId: 25,
    timeZoneId: 1,
    tourStartTime: moment(dayString + '8:00 am', 'YYYY-MM-DD hh:mm a'),
    tourEndTime: moment(dayString + '4:00 pm', 'YYYY-MM-DD hh:mm a'),
    mealStartTime:  null, // moment(dayString + '12:00 pm', 'YYYY-MM-DD hh:mm a'),
    mealEndTime: null, // moment(dayString + '1:00 pm', 'YYYY-MM-DD hh:mm a'),
    tourComment: "  ",
    notificationComment: "  ",
    myTourComment: "  ",
    showBusy: false,
    tourIndicators: "  ",
    tourPayTransactions: "  ",
    overtimeStartTime: "  ",
    overtimeEndTime: "  "
  }
};

export default blankTour;
